import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';
import { format, parseISO } from 'date-fns';
import type { ThroughputPoint } from '@/types/dashboard';

interface Props {
  data: ThroughputPoint[];
}

export function ThroughputChart({ data }: Props) {
  return (
    <div className="h-[260px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
          <defs>
            <linearGradient id="orders-fill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(22 100% 55%)" stopOpacity={0.45} />
              <stop offset="100%" stopColor="hsl(22 100% 55%)" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="dispatch-fill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(188 75% 32%)" stopOpacity={0.4} />
              <stop offset="100%" stopColor="hsl(188 75% 32%)" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="returns-fill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(220 9% 46%)" stopOpacity={0.3} />
              <stop offset="100%" stopColor="hsl(220 9% 46%)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220 13% 91%)" vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={(v) => format(parseISO(v), 'd MMM')}
            stroke="hsl(220 9% 60%)"
            fontSize={11}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            stroke="hsl(220 9% 60%)"
            fontSize={11}
            tickLine={false}
            axisLine={false}
            width={36}
          />
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: '1px solid hsl(220 13% 91%)',
              fontSize: 12,
              boxShadow: '0 4px 12px rgba(15,23,42,0.08)',
            }}
            labelFormatter={(v) => format(parseISO(v as string), 'd MMM yyyy')}
          />
          <Legend
            verticalAlign="top"
            align="right"
            iconType="circle"
            wrapperStyle={{ fontSize: 11, paddingBottom: 8 }}
          />
          <Area
            type="monotone"
            dataKey="orders"
            name="Orders"
            stroke="hsl(22 100% 55%)"
            fill="url(#orders-fill)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="dispatches"
            name="Dispatches"
            stroke="hsl(188 75% 32%)"
            fill="url(#dispatch-fill)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="returns"
            name="Returns"
            stroke="hsl(220 9% 46%)"
            fill="url(#returns-fill)"
            strokeWidth={1.5}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
